module.exports = {
	"accessRequestInvalid": "The invite to access the seller account is not valid or has expired. You may request a new one from an account administrator.",
	"accessRequestSuccess": "You now have access to the __name__ seller account.",
	"buyerPremium": "Buyer's Premium",
	"claim": {
		"request": "I am the owner of this business. Claim this listing.",
		"claimListing": "Claim this listing",
		"confirmationMessage": "If you would like to claim ownership of this business and be able to modifiy this listing, we need to send you an e-mail to confirm you own the address we have in our records:",
		"send": "Send confirmation email"
	},
	"created": "Organization created.",
	"manageAccountBtn": "Manage account",
	"methodsOfPayment": "Accepted method of payment",
	"methodsOfPayment_plural": "Accepted methods of payment",
	"noMethodsOfPayment": "None were specified by the seller.",
	"noRecentAuctions": "No recent auctions.",
	"noUpcomingAuctions": "No upcoming auctions.",
	"organizations": "organizations",
	"recentAuctions": "Recent auctions",
	"listOrganizations": {
		"header": "Directory",
		"noOrganizations": "No sellers."
	},
	"subscription": {
		"basic": "Basic",
		"premium": "Premium"
	},
	"createOrganization": {
		"header": "Create a seller account",
		"access": "You have access to the following active seller accounts. You can request access by asking a seller account administrator or by <a>creating one</a> and starting to sell today.",
		"businessName": "Business name",
		"createBtn": "Create",
		"created": "Seller account successfully created.",
		"descriptionPlaceholder": "Organization description...",
		"emailPlaceholder": "contact@example.com",
		"friendlyId": "Friendly ID",
		"friendlyidLabel": "Friendly URL",
		"h2ContactInformation": "Contact information",
		"h2GeneralInformation": "General information",
		"namePlaceholder": "Organization name"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/organization.json5
// module id = 1948
// module chunks = 6